import { i18n } from '@/plugins/i18n';
import VeeValidate from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';
import Vue from 'vue';

import '@/rules/date';
import '@/rules/iban';
import '@/rules/password';
import '@/rules/phone';
import '@/rules/siren';

Vue.use(VeeValidate, {
  i18n,
  inject: false,
  dictionary: {
    fr,
  },
});
